// Client-side money formatting mirroring the server's `Money.new(cents, currency).format`.
// Minor-unit count varies by currency (2 for USD, 0 for JPY), so derive the exponent per-currency
// instead of dividing by 100 (which was 100x wrong for zero-decimal currencies).
export function formatMoney(cents, currency) {
  const code = (currency || "usd").toUpperCase();
  const exponent = currencyExponent(code);
  const amount = (Number(cents) || 0) / 10 ** exponent;
  const whole = Number.isInteger(amount);

  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      minimumFractionDigits: whole ? 0 : exponent,
      maximumFractionDigits: exponent,
    }).format(amount);
  } catch {
    return `${whole ? amount : amount.toFixed(exponent)} ${code}`;
  }
}

// Major units (what the user types) -> minor units, using the same per-currency exponent as
// formatMoney so input and display can't drift (5 -> 500 for USD, 5 -> 5 for JPY).
export function toMinorUnits(amount, currency) {
  const code = (currency || "usd").toUpperCase();
  return Math.round((Number(amount) || 0) * 10 ** currencyExponent(code));
}

// The currency's minor-unit exponent (USD -> 2, JPY -> 0), read from Intl. Falls back to 2 if unknown.
export function currencyExponent(code) {
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency: code })
      .resolvedOptions().maximumFractionDigits;
  } catch {
    return 2;
  }
}
